import React__default from 'react';
import Button from '../Atoms/Button.js';
import Typography from '../Atoms/Typography.js';
import { useTranslation } from 'react-i18next';

function CustomizeThemeBar(_a) {
    var classes = _a.classes, onCustomizeClick = _a.onCustomizeClick;
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: "customize-theme-bar ".concat(classes) },
        React__default.createElement(Typography, { classes: "customize-theme-text", variant: 'button' }, t('common.customizeThemeMessage')),
        React__default.createElement(Button, { classes: "customize-theme-button", onClick: function () {
                onCustomizeClick === null || onCustomizeClick === void 0 ? void 0 : onCustomizeClick();
            }, variant: 'solid', size: 'lg' }, t('common.customizeTheme'))));
}

export { CustomizeThemeBar as default };
//# sourceMappingURL=CustomizeThemeBar.js.map
